import { Icon } from '@iconify/react';
import FormSection from './FormSection';
import { labelCls, errorCls, hintCls, controlCls } from './formStyles';
import { LIMITS, fmtPhone } from '../../visitorConstants';

const ContactFields = ({ form, errors, set, mode, normalizedPhone, phoneWillChange, onPhoneBlur }) => (
    <FormSection icon="mdi:phone-outline" title="Contact details">
        <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-3 tw-gap-3">
            <div>
                <label className={labelCls}>Phone <span className="tw-text-rose-500">*</span></label>
                <input
                    type="tel"
                    inputMode="tel"
                    value={form.phone}
                    onChange={e => set('phone', e.target.value)}
                    onBlur={onPhoneBlur}
                    maxLength={LIMITS.phone}
                    placeholder="9876543210"
                    className={`${controlCls(!!errors.phone)} tw-font-mono`}
                />
                {/* The number is stored verbatim and unique per society, so the
                    user is told what will actually be saved before they commit. */}
                {errors.phone
                    ? <p className={errorCls}>{errors.phone}</p>
                    : phoneWillChange && (
                        <p className="tw-mb-0 tw-text-[10px] tw-text-gray-500 tw-mt-1 tw-flex tw-items-center tw-gap-1">
                            <Icon icon="mdi:information-outline" />
                            Will be saved as <span className="tw-font-mono tw-font-semibold">{fmtPhone(normalizedPhone)}</span>
                        </p>
                    )}
                {mode === 'create' && !errors.phone && !phoneWillChange && (
                    <p className={hintCls}>One record per number — a number already in use will be rejected</p>
                )}
            </div>

            <div>
                <label className={labelCls}>Email</label>
                <input
                    type="email"
                    value={form.email || ''}
                    onChange={e => set('email', e.target.value)}
                    maxLength={LIMITS.email}
                    placeholder="rajesh@example.com"
                    className={controlCls(!!errors.email)}
                />
                {errors.email && <p className={errorCls}>{errors.email}</p>}
            </div>

            <div>
                <label className={labelCls}>Company</label>
                <input
                    type="text"
                    value={form.company_name || ''}
                    onChange={e => set('company_name', e.target.value)}
                    maxLength={LIMITS.company_name}
                    placeholder="e.g. ABC Plumbing Services"
                    className={controlCls(false)}
                />
            </div>
        </div>

        <div className="tw-mt-3">
            <label className={labelCls}>Address</label>
            <textarea
                rows={2}
                value={form.address || ''}
                onChange={e => set('address', e.target.value)}
                maxLength={LIMITS.address}
                placeholder="Where the visitor is coming from"
                className={`${controlCls(false)} tw-resize-none`}
            />
            <p className={hintCls}>{(form.address || '').length}/{LIMITS.address}</p>
        </div>
    </FormSection>
);

export default ContactFields;
